import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=16b31b35&scoped=true"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"
import style0 from "./downloads.vue?vue&type=style&index=0&id=16b31b35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b31b35",
  null
  
)

export default component.exports